/** @jsx jsx */
import * as React from 'react';

import { css, jsx } from '@compiled/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import styled from 'styled-components';
import * as grid from '@helpcenter/styles/src/grid';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { token } from '@atlaskit/tokens';

const isCompiledCssEnabled = (): boolean => FeatureGates.checkGate('help_center_login_compiled_css');

interface LogoStatelessProps {
    url?: string | null;
    name: string;
    topBarTextColor?: string;
}

const LogoStateless: React.FunctionComponent<LogoStatelessProps> = ({ url, name, topBarTextColor }) => {
    if (isCompiledCssEnabled()) {
        const compiledContent = url ? (
            <img src={url} alt={name} style={{ height: `${imageHeight}px` }} />
        ) : (
            <span>{name}</span>
        );

        return (
            <div css={rootCompiledStyles} style={{ height: `${imageHeight}px`, color: topBarTextColor || 'inherit' }}>
                {compiledContent}
            </div>
        );
    }

    const content = url ? <ImageStyled src={url} alt={name} /> : <span>{name}</span>;
    return <RootStyled topBarTextColor={topBarTextColor}>{content}</RootStyled>;
};

export default LogoStateless;

const imageHeight = grid.unitless * 5;

// Compiled CSS styles
const rootCompiledStyles = css({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: token('space.075', '6px'),
    paddingRight: token('space.075', '6px'),
    paddingBottom: token('space.075', '6px'),
    paddingLeft: token('space.075', '6px'),
    fontWeight: token('font.weight.semibold', '600'),
});

// Styled-components version (legacy)
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const RootStyled = styled.div`
    height: ${imageHeight}px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: ${token('space.075', '6px')};
    font-weight: 600;
    color: ${(props: { topBarTextColor?: string }) => props.topBarTextColor || 'inherit'};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const ImageStyled = styled.img`
    height: ${imageHeight}px;
`;
